
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M9.75 6.4h4.85v8.85c0 .367-.136.697-.394.956a1.323 1.323 0 01-.956.394H2.75c-.367 0-.697-.136-.956-.394a1.323 1.323 0 01-.394-.956V2.75c0-.367.136-.697.394-.956.26-.258.589-.394.956-.394H9.6v4.85c0 .05.01.074.043.107.033.033.057.043.107.043z"}}),_c('path',{staticClass:"fill",attrs:{"d":"M11 12.75v-.5a.243.243 0 00-.07-.18.243.243 0 00-.18-.07h-5.5a.243.243 0 00-.18.07.243.243 0 00-.07.18v.5c0 .073.023.133.07.18.047.047.107.07.18.07h5.5a.243.243 0 00.18-.07.243.243 0 00.07-.18zM11 10.75v-.5a.243.243 0 00-.07-.18.243.243 0 00-.18-.07h-5.5a.243.243 0 00-.18.07.243.243 0 00-.07.18v.5c0 .073.023.133.07.18.047.047.107.07.18.07h5.5a.243.243 0 00.18-.07.243.243 0 00.07-.18zM11 8.75v-.5a.243.243 0 00-.07-.18.243.243 0 00-.18-.07h-5.5a.243.243 0 00-.18.07.243.243 0 00-.07.18v.5c0 .073.023.133.07.18.047.047.107.07.18.07h5.5a.243.243 0 00.18-.07.243.243 0 00.07-.18zM14.922 5.465c.1.1.199.228.298.385H10.2V.8c.156.1.284.2.383.3l4.34 4.365z"}})])])
          )
        }
      }
    